import React from "react";
import { connect } from "react-redux";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import Layout from "components/Layout";
import Modal from "components/Modal";
import PendingExpenses from "pages/ExpensesPending";
import MobileExpensesView from "components/Expenses/Mobile/MobileExpensesView";
import { hideModal } from "actions/modalActions";

/**
 * Tablet/desktop: tabla de pendientes. Móvil: misma shell unificada que /expenses (pestaña aprobar).
 */
const PendingExpensesResponsive = ({ hideModal }) => (
	<>
		<TabletOrDesktop>
			<PendingExpenses />
		</TabletOrDesktop>
		<Mobile>
			<>
				<Layout
					className="page-expenses page-expenses-pending mobile"
					context="expenses"
				>
					<MobileExpensesView />
				</Layout>
				<Modal hideModal={hideModal} />
			</>
		</Mobile>
	</>
);

export default connect(null, { hideModal })(PendingExpensesResponsive);
